
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
@Component({
  components: {}
})
export default class Course extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  companyArr: any = [];

  imgW: any = 0;

  mounted() {
    let companyArr0 = [];
    let companyArr1 = [];
    let companyArr2 = [];
    let companyArr3 = [];
    let companyArr4 = [];
    for (let index = 0; index < 10; index++) {
      companyArr0.push({
        img: require("@/assets/company/company" + index + ".png")
      });
    }
    for (let index = 10; index < 20; index++) {
      companyArr1.push({
        img: require("@/assets/company/company" + index + ".png")
      });
    }
    for (let index = 20; index < 30; index++) {
      companyArr2.push({
        img: require("@/assets/company/company" + index + ".png")
      });
    }
    for (let index = 30; index < 40; index++) {
      companyArr3.push({
        img: require("@/assets/company/company" + index + ".png")
      });
    }
    for (let index = 40; index < 50; index++) {
      companyArr4.push({
        img: require("@/assets/company/company" + index + ".png")
      });
    }

    this.companyArr.push(companyArr0);
    this.companyArr.push(companyArr1);
    this.companyArr.push(companyArr2);
    this.companyArr.push(companyArr3);
    this.companyArr.push(companyArr4);

    console.log("🚀 ~ Course ~ mounted ~ this.companyArr:", this.companyArr);
    var width = document.documentElement.clientWidth;
    console.log("🚀 ~ Course ~ mounted ~ width:", width);
    this.imgW = width / 10 - 18;
  }
}
